export class Statutory{
    id:number=0;
    name:string;
}